/**
 * Безопасно получает значение поля из объекта, проверяя оба варианта:
 * snake_case и camelCase
 * 
 * @param {Object} obj - объект для поиска поля
 * @param {string} camelCaseName - имя поля в camelCase (например, 'createdAt')
 * @param {string} snakeCaseName - имя поля в snake_case (например, 'created_at')
 * @param {*} defaultValue - значение по умолчанию, если поле не найдено
 * @returns {*} значение поля или defaultValue
 * 
 * @example
 * const date = getFieldValue(purchase, 'createdAt', 'created_at', null);
 * const paymentType = getFieldValue(purchase, 'paymentType', 'payment_type');
 */
export function getFieldValue(obj, camelCaseName, snakeCaseName = null, defaultValue = undefined) {
  if (!obj || typeof obj !== 'object') {
    return defaultValue;
  }
  
  // Если snake_case имя не указано, генерируем его из camelCase
  if (!snakeCaseName) {
    snakeCaseName = camelCaseName.replace(/([A-Z])/g, '_$1').toLowerCase();
  }
  
  // Проверяем оба варианта
  return obj[snakeCaseName] !== undefined 
    ? obj[snakeCaseName] 
    : (obj[camelCaseName] !== undefined ? obj[camelCaseName] : defaultValue);
}

/**
 * Безопасно получает значение поля из объекта с автоматическим определением формата
 * 
 * @param {Object} obj - объект для поиска поля
 * @param {string} fieldName - имя поля (будет проверено в обоих форматах)
 * @param {*} defaultValue - значение по умолчанию
 * @returns {*} значение поля или defaultValue
 * 
 * @example
 * const date = getField(obj, 'createdAt'); // проверит и createdAt, и created_at
 */
export function getField(obj, fieldName, defaultValue = undefined) {
  return getFieldValue(obj, fieldName, null, defaultValue);
}
